<div class="p-4">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
  <div class="loader-overlay" *ngIf="isLoading">
    <p-progress-spinner ariaLabel="loading" />
  </div>

  <div class="card bg-white border-round">
    <div class="card-header p-3 ml-auto border-bottom-1 border-gray-200">
      <div class="flex w-full items-center">
        <h2 class="m-0">Contract Details List</h2>
      </div>
      <div class="flex justify-content-end gap-2">
        <p-button
          label="Search"
          icon="pi pi-check"
          (click)="submitForm()"
          [loading]="isLoading"
        ></p-button>
        
        <p-button
          label="Export"
          icon="pi pi-file"
          styleClass="p-button-help"
          (click)="exportExcel()"
          [loading]="isLoading"
        ></p-button>
        
        <!-- <p-button
          label="Reset"
          icon="pi pi-refresh"
          styleClass="p-button-secondary"
          (click)="onReset()"
        ></p-button> -->
        
      </div>
    </div>
    <div class="card-body p-2">
      <form
        [formGroup]="filterForm"
        novalidate
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="off"
      >
        <div class="grid formgrid p-fluid">
          
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-file"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <input
                  type="text"
                  pInputText
                  formControlName="contractNo"
                  inputId="contractNo"
                  class="w-full"
                  placeholder="Enter Contract No"
                />
                <label for="contractNo">Contract No</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-users"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-multiSelect
                  formControlName="customer"
                  [options]="filteredCustomers"
                  optionLabel="customerName"
                  inputId="customer"
                  styleClass="w-full"
                  [filter]="true"
                  display="chip"
                >
                  <ng-template let-customer pTemplate="selectedItem">
                    <div *ngIf="customer">
                      {{ customer.customerNumber }} -
                      {{ customer.customerName }}
                    </div>
                  </ng-template>
                  <ng-template let-customer pTemplate="item">
                    <div>
                      {{ customer.customerNumber }} -
                      {{ customer.customerName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-customer>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #customerInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (input)="filterCustomers(customerInput.value)"
                      />
                    </p-inputgroup>
                  </ng-template>
                </p-multiSelect>
                <label for="customer">Customer</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['customer'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-briefcase"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-multiSelect
                  formControlName="business"
                  [options]="filteredBusinesses"
                  optionLabel="businessName"
                  inputId="business"
                  styleClass="w-full"
                  [filter]="true"
                  display="chip"
                >
                  <ng-template let-business pTemplate="selectedItem">
                    <div *ngIf="business">
                      {{ business.businessCode }} -
                      {{ business.businessName }}
                    </div>
                  </ng-template>
                  <ng-template let-business pTemplate="item">
                    <div>
                      {{ business.businessCode }} -
                      {{ business.businessName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-business>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #businessInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (input)="filterBusinesses(businessInput.value)"
                      />
                    </p-inputgroup>
                  </ng-template>
                </p-multiSelect>
                <label for="business">Business</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['business'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-briefcase"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-multiSelect
                  formControlName="vendor"
                  [options]="filteredSuppliers"
                  optionLabel="supplierName"
                  inputId="vendor"
                  styleClass="w-full"
                  [filter]="true"
                  display="chip"
                >
                  <ng-template let-vendor pTemplate="selectedItem">
                    <div *ngIf="vendor">
                      {{ vendor.supplierNumber }} -
                      {{ vendor.supplierName }}
                    </div>
                  </ng-template>
                  <ng-template let-vendor pTemplate="item">
                    <div>
                      {{ vendor.supplierNumber }} -
                      {{ vendor.supplierName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-vendor>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #vendorInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (input)="filterSuppliers(vendorInput.value)"
                      />
                    </p-inputgroup>
                  </ng-template>
                </p-multiSelect>
                <label for="vendor">Supplier</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['vendor'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-building"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <p-multiSelect
                  formControlName="contractType"
                  [options]="contractTypes"
                  optionLabel="label"
                  optionValue="value"
                  inputId="contractType"
                  class="w-full"
                  display="chip"
                ></p-multiSelect>
                <label for="contractType">Contract Type</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['contractType'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="startDateActive"
                  [showIcon]="true"
                  inputId="startDateActive"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                ></p-datePicker>
                <label for="startDateActive">Start Date</label>
              </p-iftalabel>
              <p-inputgroup-addon>
                <p-button
                  type="button"
                  icon="pi pi-times"
                  (click)="filterForm.controls['startDateActive'].reset()"
                  styleClass="p-button-secondary addOnBtnClear"
                ></p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-file"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <input
                  type="text"
                  pInputText
                  formControlName="batchNumber"
                  inputId="batchNumber"
                  class="w-full"
                  placeholder="Enter Batch Number"
                />
                <label for="batchNumber">Batch Number</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card mt-2">
    <p-table
      #dt
      [value]="detailRows"
      [rows]="25"
      [paginator]="true"
      [paginatorDropdownAppendTo]="'body'"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[25, 50, 100, 500]"
      [totalRecords]="totalRecords"
      (onLazyLoad)="loadContractDetails($event)"
      [loading]="isLoading"
      [lazy]="true"
      dataKey="id"
      styleClass="p-datatable-striped overflow-x-auto"
    >
      <ng-template pTemplate="caption">
        <div class="flex w-full items-center">
          <h2 class="m-0">Contract Details</h2>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th>Business Name</th>
          <th>Business No</th>
          <th>Vendor Name</th>
          <th>Vendor No</th>
          <th>Vendor Site</th>
          <th>Item</th>
          <th>Rebate</th>
          <th>JBP</th>
          <th>Fixed JBP</th>
          <th>Slab 1</th>
          <th>Slab 1 %</th>
          <th>Slab 2</th>
          <th>Slab 2 %</th>
          <th>Slab 3</th>
          <th>Slab 3 %</th>
          <th>Deliverables</th>
          <th>Calculation Method</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr>        
          <td>{{ row.business?.businessName }}</td>
          <td>{{ row.business?.businessCode }}</td>
          <td>{{ row.vendor?.supplierName }}</td>
          <td>{{ row.vendor?.supplierNumber }}</td>
          <td>{{ row.vendorSite?.supplierSiteNumber }}</td>
          <td>
            {{
              row.item
                ? row.item.itemNumber +
                  ' - ' +
                  row.item.erpItemNameE
                : ''
            }}
          </td>
          <td>{{ row.rebate }}</td>
          <td>{{ row.jbpPrc }}</td>
          <td>{{ row.fixedJbp }}</td>
          <td>{{ row.progressiveSlap1 }}</td>
          <td>{{ row.progressiveSlab1Percent }}</td>
          <td>{{ row.progressiveSlap2 }}</td>
          <td>{{ row.progressiveSlab2Percent }}</td>
          <td>{{ row.progressiveSlap3 }}</td>
          <td>{{ row.progressiveSlab3Percent }}</td>
          <td>{{ row.deliverables }}</td>
          <td>{{ row.calculationMethod }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">No Contract Details found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
